import { axiosInstance, getCurrentLang } from "@/util/http";
import store from "@/store";

/**
 * 退款（JSON body + query params，与移动端一致）
 */
export function refunds(data, params) {
	return axiosInstance({
		url: '/order/shop/refunds/refunds',
		method: 'post',
		data: {
			body: {
				method: data.method,
				reason: data.reason,
			},
			params: {
				...getCurrentLang(),
				orderId: params.orderId,
				orderItemId: params.orderItemId,
				quantity: Number(params.quantity),
			},
		},
		headers: store.getters.headersJson,
	})
}
